import entitiesSearch from 'app/modules/search/sagas/entitiesSearch';
import rulesSearch from 'app/modules/search/sagas/rulesSearch';
import alertsSearch from 'app/modules/search/sagas/alertsSearch';
import eventsSearch from 'app/modules/search/sagas/eventsSearch';
import teamsSearch from 'app/modules/search/sagas/teamsSearch';

const sagaRegistry = [
  entitiesSearch,
  rulesSearch,
  alertsSearch,
  eventsSearch,
  teamsSearch,
];

export default sagaRegistry;
